module.exports = function () { /* empty */ };



//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/~/core-js/library/modules/_add-to-unscopables.js
// module id = 101
// module chunks = 0 1 2 3